import React, { useState } from "react";

function useCollapseState() {
  const [collapse, setCollapse] = useState(false);

  return { collapse, setCollapse };
}

export default useCollapseState;
